import {
    EOD_INIT,
    EOD_SNAPSHOT,
    EOD_SNAPSHOT_DENOM
} from '../constants/ActionTypes';

const INIT_STATE = {
    eodsnap: [],
    eodSnapDenominations: [],
    show: false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EOD_SNAPSHOT: {
            return {
                ...state,
                show: true,
                eodsnap: action.payload
            }
        }
        case EOD_SNAPSHOT_DENOM: {
            return {
                ...state,
                show: true,
                eodSnapDenominations: action.payload
            }
        }
        case EOD_INIT: {
            return {
                ...state,
                show: false
            }
        }
        default:
            return state;
    }
}